import { Api, ModelRow } from "@mcleod/core";
import { AutogenLayoutResetCustomerBalances } from "./autogen/AutogenLayoutResetCustomerBalances";
import { Toast } from "@mcleod/components";
import { CustomerResetLayoutProps, ResetTypeDescription } from "./CustomerResets";
import { ProcessLogViewer } from "@mcleod/general";
import { CommonDialogs } from "@mcleod/common";

export class ResetCustomerBalances extends AutogenLayoutResetCustomerBalances {
    private processLogEnabled: boolean = false;
    private setActionButtonsBusy: (isBusy: boolean) => void;

    // Called from parent layout's onLoad method
    initialize(props: CustomerResetLayoutProps) {
        this.processLogEnabled = props.processLogEnabled;
        this.initializePanelProcessLog();
        this.setActionButtonsBusy = props.setActionButtonsBusy || null;
    }

    initializePanelProcessLog() {
        this.panelProcessLog.visible = this.processLogEnabled;
        if (this.processLogEnabled) {
            this.sourceProcessLog.search({ descr: ResetTypeDescription.RESET_BALANCES });
        }
    }

    buttonRunResetOnClick() {
        if (this.setActionButtonsBusy) {
            this.setActionButtonsBusy(true);
        }
        const customers = this.textboxCustomerIds.lookupModelData || [] as ModelRow[];
        Api.post("lme/ar/reset-customer-balances", { customers: customers }).then(() => {
            Toast.showSuccessToast("Calculations and balance reset is complete");
        }).catch((error) => {
            CommonDialogs.showError("An error occurred while resetting customer balances: " + (error?.message || "Unknown error"));
        }).finally(() => {
            if (this.processLogEnabled) {
                // Refresh the process log information with latest data
                this.sourceProcessLog.search({ descr: ResetTypeDescription.RESET_BALANCES });
            }

            if (this.setActionButtonsBusy) {
                this.setActionButtonsBusy(false);
            }
        });
    }

    buttonProcessLogOnClick() {
        ProcessLogViewer.showInSlideoutDecorator(ResetTypeDescription.RESET_BALANCES);
    }
}
